export default {"src":"/_next/static/media/face_with_head-bandage_color.4eef18d9.svg","height":32,"width":32};